AFRAME.registerComponent("transform-listener", {
  schema: {
    throttleInterval: { type: "number", default: 100 },
    enabled: { type: "boolean", default: false }
  },
  init: function () {
    this.prevPosition = new THREE.Vector3();
    this.prevRotation = new THREE.Euler();
    this.prevScale = new THREE.Vector3();
    this.lastTickTime = 0;
    this.throttleInterval = this.data.throttleInterval;
  },
  tick: function (time, delta) {
    if (!this.data.enabled) return;

    if (time - this.lastTickTime < this.throttleInterval) {
      return;
    }

    this.lastTickTime = time;

    const el = this.el;
    const object3D = el.object3D;

    if (!object3D.position.equals(this.prevPosition)) {
      this.prevPosition.copy(object3D.position);
      el.emit("transformchanged", { type: "position", value: object3D.position, oldValue: this.prevPosition, el });
    }

    if (!object3D.rotation.equals(this.prevRotation)) {
      this.prevRotation.copy(object3D.rotation);
      el.emit("transformchanged", { type: "rotation", value: object3D.rotation, el });
    }

    if (!object3D.scale.equals(this.prevScale)) {
      this.prevScale.copy(object3D.scale);
      el.emit("transformchanged", { type: "scale", value: object3D.scale, el });
    }

    if (object3D.visible !== this.prevVisible) {
      this.prevVisible = object3D.visible;
      el.emit("transformchanged", { type: "visible", value: object3D.visible, el });
    }
  }
});
